var initIntersection = (element, intersectionAction) => {
    var observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                intersectionAction(entry);

                obs.unobserve(entry.target);
            }
        });
    }, {threshold: 1.0});

    observer.observe(element);
};

var initMutation = (element, mutationAction) => {
    var mutationObserver = new MutationObserver(mutationAction);

    mutationObserver.observe(element, {subtree: true, childList: true});
};

module.exports = {
    initIntersection: initIntersection,
    initMutation: initMutation
};
